/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import PropTypes from 'prop-types';

export const cellCoverageRatingPropTypes = {
    carrier: PropTypes.string,
    rating: PropTypes.string,
};

export type cellCoverageRating = { carrier: string; rating: string };

export const publicReviewPropTypes = {
    id: PropTypes.string,
    account_id: PropTypes.string,
    location_id: PropTypes.string,
    location_type: PropTypes.string,
    reservation_id: PropTypes.string,
    created_at: PropTypes.string,
    modified_at: PropTypes.string,
    first_name: PropTypes.string,
    last_initial: PropTypes.string,
    location_description: PropTypes.string,
    helpful_rating: PropTypes.number,
    helpful_votes_count: PropTypes.number,
    not_helpful_votes_count: PropTypes.number,
    rating: PropTypes.number,
    review: PropTypes.string,
    reservation_info: PropTypes.shape({
        campsite_id: PropTypes.string,
        end_date: PropTypes.string,
        facility_description: PropTypes.string,
        facility_name: PropTypes.string,
        product_category: PropTypes.string,
        product_description: PropTypes.string,
        product_name: PropTypes.string,
        rec_area_name: PropTypes.string,
        reservation_number: PropTypes.string,
        start_date: PropTypes.string,
    }),
    cell_coverage_ratings: PropTypes.arrayOf(
        PropTypes.shape(cellCoverageRatingPropTypes)
    ),
    moderator_approved: PropTypes.bool,
};

export type PublicReviewType = {
    id?: string;
    account_id: string;
    location_id: string;
    location_type: string;
    reservation_id: string;
    created_at: string;
    modified_at: string;
    first_name: string;
    last_initial: string;
    location_description: string;
    helpful_rating: number;
    helpful_votes_count: number;
    not_helpful_votes_count: number;
    rating: number;
    review: string;
    reservation_info: {
        campsite_id: string | null | undefined;
        end_date: string;
        facility_description: string;
        facility_name: string;
        product_category: string;
        product_description: string;
        product_name: string;
        rec_area_name: string;
        reservation_number: string;
        start_date: string;
    };
    cell_coverage_ratings: Array<cellCoverageRating>;
    moderator_approved: boolean;
};

export type aiReview = {
    created_at: string;
    location_id: string;
    location_type: string;
    helpful_votes_count: number;
    not_helpful_votes_count: number;
    summary: string;
};

export type reviewType = PublicReviewType & {
    private_internal_review: string;
};

export type putReviewRequest = {
    reservation_id: string;
    rating: string;
    review: string;
    private_internal_review: string;
    cell_coverage_ratings: Array<cellCoverageRating>;
};

export type fetchPublicReviewsRequest = {
    locationType: string;
    locationId: string;
    pageSize: number;
    sortKey: string;
    startKey: string | null | undefined;
    rating: string | null | undefined;
};

export type fetchAIReviewRequest = {
    locationType: string;
    locationId: string;
};

export type publicReviewsAction = {
    type: string;
    payload: {
        pageSize: number | null | undefined;
        data: PublicReviewType[] | null | undefined;
        startKey: string | null | undefined;
        error: string | null | undefined;
    };
};

export type fetchReviewRequest = {
    reservationId: string;
};
